import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.franchisee.view.FranchiseeStockView.';

  public static readonly stock = `${Id.prefix}stock`;
  public static readonly stockSaved = `${Id.prefix}stockSaved`;
}

export class LangFranchiseeStockView {
  private constructor() {}

  public static stock(): string {
    return interpolate(Id.stock);
  }
  public static stockSaved(): string {
    return interpolate(Id.stockSaved);
  }
}

export class FranchiseeStockViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.stock, "{{glossary 'stock:plural'}}", 'Section title and caption for stock (plural)');
    register.add(Id.stockSaved, "{{glossary 'stock:plural'}} saved", 'Toast message for stock saved (plural)');
  }
}
